document.addEventListener("DOMContentLoaded", () => {
    const body = document.querySelector('body'),
        achievementsTriggers = document.querySelectorAll('.js-achievements-modal-trigger');

    function toggleModal(modalContent, isVisible) {
        modalContent.style.display = isVisible ? 'block' : 'none';
        body.classList.toggle('ov-hidden', isVisible);
    }

    function closeModal(modalContent) {
        toggleModal(modalContent, false);
    }

    function handleModalClick(event, modalContent) {
        if (event.target === modalContent) {
            closeModal(modalContent);
        }
    }

    for (let i = 0; i < achievementsTriggers.length; i++) {
        achievementsTriggers[i].addEventListener('click', function () {
            let modalId = this.getAttribute('data-achievements-modal'),
                modalContent = document.querySelector(`[data-achievements-modal-content="${modalId}"]`);
            toggleModal(modalContent, true);

            modalContent.addEventListener('click', (event) => handleModalClick(event, modalContent));

            const closeModalButtons = modalContent.querySelectorAll('.js-close-modal');
            for (let j = 0; j < closeModalButtons.length; j++) {
                closeModalButtons[j].addEventListener('click', () => closeModal(modalContent));
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", () => {
    const $formModal = $('#form-modal');
    const $banner = $('.form-modal__banner');

    // Subscribe Popup
    const $linkSubscribeOpen = $('a[href="#open-subscribe-popup"]');
    const $formSubscribe = $('#form-modal-subscribe');

    // Auto-open modal if it exists on the page
    if ($formModal.length) {
        setTimeout(function () {
            $formModal.addClass('is-open');
            $('body').css('overflow', 'hidden');
        }, 150);
    }

    function closeFormModal() {
        $('.form-modal').removeClass('is-open');
        $('body').css('overflow', '');

        // Optional: Since it's a dedicated page, closing the modal might mean leaving the page.
        if ($formModal.length) {
            window.history.back();
        }
    }

    // Function to update the text in the banner
    function syncStepTitle() {
        const $currentStep = $formModal.find('.cf7mls_current_fs');
        const stepText = $currentStep.find('.contact-form__step-indicator').text();

        if (stepText) {
            if ($banner.find('.banner-text').length === 0) {
                $banner.prepend('<span class="banner-text"></span>');
            }
            $banner.find('.banner-text').text(stepText.trim());
        }
    }

    // if the user moves to the next/previous step
    const formElement = document.querySelectorAll('.fieldset-cf7mls');

    if (formElement.length) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === "class") {
                    syncStepTitle();
                }
            });
        });

        formElement.forEach((item) => {
            observer.observe(item, {
                attributes: true,
                subtree: false,
                attributeFilter: ['class']
            });
        });
    }

    // Close triggers
    $('.js-modal-close, .form-modal__close').on('click', function (e) {
        dl.log('close');
        e.preventDefault();
        closeFormModal();
    });

    // Close on Escape key
    $(document).on('keydown', function (e) {
        if (e.key === "Escape" && $('.form-modal').hasClass('is-open')) {
            closeFormModal();
        }
    });

    // Ope Subscribe trigger
    $linkSubscribeOpen.on('click', function (e) {
        e.preventDefault();
        $formSubscribe.addClass('is-open');
        $('body').css('overflow', 'hidden');
    });
});